/* eslint semi:0 */
import { external } from '../../utils/script'

const FB_CONTAINER_SELECTOR = '.facebook-container'
const FB_SCRIPT = 'facebook'
if (document.querySelector(FB_CONTAINER_SELECTOR)) {
  let fb = external.load({ name: FB_SCRIPT })
  fb(() => window.FB.XFBML.parse())
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/facebook/facebookEmbedProvider.js